import { render, staticRenderFns } from "./platformStoreList.vue?vue&type=template&id=0a02bd28"
import script from "./platformStoreList.vue?vue&type=script&lang=js"
export * from "./platformStoreList.vue?vue&type=script&lang=js"
import style0 from "./platformStoreList.vue?vue&type=style&index=0&id=0a02bd28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports